import { memo } from 'react';

import CustomRoleIconSVG from '@/assets/custom-role-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICustomRoleIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={CustomRoleIconSVG} {...props} />
);

export const CustomRoleIcon = memo(ICustomRoleIcon) as typeof ICustomRoleIcon;
